import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ba3fd58"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增项目")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("审核状态：")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("审核备注：")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("违规重审")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("商品")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("信息")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("禁用")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "项目推荐" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.addApply
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "inline",
          model: _ctx.formState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "项目名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                  placeholder: "项目名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "店铺名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.shop_name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.shop_name) = $event)),
                  placeholder: "店铺名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: $setup.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: $setup.onReset }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'goods_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.goods_image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'images')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 1,
                  src: record.images,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'background_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 2,
                  src: record.background_image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#2db7f5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'type')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (record.type == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "商品"))
                    : _createCommentVNode("", true),
                  (record.type == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "信息"))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "设置状态?",
                    onConfirm: ($event: any) => ($setup.onStatus(record,1)),
                    onCancel: ($event: any) => ($setup.onStatus(record,0)),
                    "ok-text": "正常",
                    "cancel-text": "禁用"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[11] || (_cache[11] = ($event: any) => ($setup.onSubmit('formRef'))),
      "ok-text": _ctx.oKtext,
      width: "60%"
    }, {
      default: _withCtx(() => [
        (_ctx.showtype == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_a_input, {
                placeholder: "商家名称（非必填）",
                style: {"width":"200px"},
                value: _ctx.name,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_a_select, {
                ref: "select",
                value: _ctx.formState.belonging_app_id,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.belonging_app_id) = $event)),
                placeholder: "请选择所属平台",
                onChange: $setup.sysChange,
                style: {"margin-left":"10px","width":"200px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appData, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.app_tag
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["value", "onChange"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                type: "primary",
                onClick: $setup.onSearch2
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: $setup.onReset2
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_ctx.showtype == 1)
                ? (_openBlock(), _createBlock(_component_a_table, {
                    key: 0,
                    rowKey: record=>record.id,
                    dataSource: _ctx.goolList,
                    "row-selection": { type: 'radio', onChange: $setup.onSelect, selectedRowKeys: _ctx.multipleSelection, },
                    columns: $setup.columns2,
                    bordered: "",
                    pagination: $setup.pagination2,
                    onChange: $setup.handleTableChange2,
                    style: {"margin-top":"10px"}
                  }, {
                    bodyCell: _withCtx(({ column, text, record }) => [
                      (column.key === 'tags')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", null, [
                              _hoisted_15,
                              _createElementVNode("span", null, [
                                _createVNode(_component_a_tag, { color: "blue" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(record.audit_status == 1 ? '审核通过' : '未通过'), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_16,
                              _createElementVNode("span", null, _toDisplayString(record.audit_remark), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (column.key === 'action')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_a_button, { size: "small" }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              size: "small",
                              style: {"margin-left":"10px"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            }),
                            (_ctx.searches.type == 1)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  size: "small",
                                  style: {"margin-left":"10px"},
                                  onClick: ($event: any) => (_ctx.goodsReAudit(record))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.searches.type == 4)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  size: "small",
                                  style: {"margin-left":"10px"}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_21
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["rowKey", "dataSource", "row-selection", "columns", "pagination", "onChange"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showtype == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_a_form, {
                ref: "formRef",
                rules: $setup.rules,
                model: _ctx.formState,
                name: "basic",
                "label-col": { span: 2 },
                "wrapper-col": { span: 20 },
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  ( _ctx.shop_name_title!== '' )
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 0,
                        label: "店铺"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.shop_name_title), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ( _ctx.sysName!== '' )
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 1,
                        label: "所属平台"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(_ctx.sysName), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_form_item, {
                    label: "项目名称",
                    name: "name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formState.name,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.name) = $event)),
                        placeholder: "请输入项目名称"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "类型",
                    name: "type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        ref: "select",
                        value: _ctx.formState.type,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.type) = $event)),
                        placeholder: "请选择所属类型"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 2 }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "开始时间",
                    name: "validity_time_start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_date_picker, {
                        value: _ctx.formState.validity_time_start,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.validity_time_start) = $event)),
                        "show-time": { defaultValue: $setup.dayjs('00:00:00', 'HH:mm:ss') },
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        placeholder: "请选择开始时间",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "show-time"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "结束时间",
                    name: "validity_time_end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_date_picker, {
                        value: _ctx.formState.validity_time_end,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.validity_time_end) = $event)),
                        "show-time": { defaultValue: $setup.dayjs('00:00:00', 'HH:mm:ss') },
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        placeholder: "请选择结束时间",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "show-time"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "状态",
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        ref: "select",
                        value: _ctx.formState.status,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.status) = $event)),
                        placeholder: "请选择状态"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "排序",
                    name: "sort"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formState.sort,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.sort) = $event)),
                        placeholder: "请输入排序"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "ok-text"])
  ]))
}